export const STATES = {
  VISIBLE: 'VISIBLE',
  HIDDEN: 'HIDDEN',
};

const isFulfillmentLastItemPosition = (available, fulfillment, stock) => {
  if (typeof available !== 'string' || typeof fulfillment !== 'string' || typeof stock !== 'string') {
    return false;
  }
  return available === STATES.VISIBLE && fulfillment === STATES.VISIBLE && stock === STATES.HIDDEN;
};

export { isFulfillmentLastItemPosition };
